import { useEffect, useRef } from "react";

/**
 * 监听用户是向上滚动还是向下滚动
 */

interface ItargetDom extends Window {
  scrollTop: number;
}
export const DIRECTION = {
  up: "up", // 向上
  down: "down", //向下
};
export function useListenScrollDirection(
  upCallback,
  downCallback,
  target = () => window
) {
  const prevScrollpos = useRef(0);
  const preDirection = useRef(undefined);
  useEffect(() => {
    let targetDom = target() as unknown as ItargetDom;

    const handleScroll = () => {
      const currentScrollPos = targetDom.scrollY || targetDom.scrollTop;

      if (prevScrollpos.current >= currentScrollPos) {
        // 用户向上滚动
        if (typeof upCallback === "function") {
          upCallback(preDirection.current);
          preDirection.current = DIRECTION.up;
        }
      } else {
        // 用户向下滚动
        if (typeof downCallback === "function") {
          downCallback(preDirection.current);
          preDirection.current = DIRECTION.down;
        }
      }
      prevScrollpos.current = currentScrollPos;
    };
    targetDom.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      targetDom.removeEventListener("scroll", handleScroll);
    };
  }, [downCallback, target, upCallback]);
}
